import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import modules from './modules'
import syncChannel from '@/modules/attendance/store/syncChannel'

Vue.use(Vuex)
const store = new Vuex.Store({
  getters,
  modules,
  plugins: [syncChannel]
})

export default store
